import { SearchOffers } from '@lambda/commons/apis/elasticsearch/types';
import { useEffect } from 'react';
import cn from 'classnames';
import Placeholder from './Placeholder';
import ProductCard from '../ProductCard';
import Slider from '@/components/slider/Slider';

import { breakpoints } from '@/lib/collections/category/helpers';

const ProductGrid = ({
  offers,
  setShowSection,
  loading,
}: {
  offers: SearchOffers[] | null;
  setShowSection: (val: boolean) => void;
  loading: boolean;
}) => {
  useEffect(() => {
    if (offers && offers.length < 6) setShowSection(false);
  }, [offers]);

  if (!offers || (!offers && loading)) return <Placeholder />;

  return (
    <div
      className={cn('w-full lg:w-3/5', {
        'grid-rows-2': offers.length > 3,
      })}
    >
      <div className="hidden gap-3 lg:grid lg:grid-cols-3">
        {offers.map((offer) => (
          <ProductCard offer={offer} key={offer.key} />
        ))}
      </div>
      <div className="relative lg:hidden">
        <Slider breakpoints={breakpoints}>
          {offers.map((offer) => (
            <ProductCard offer={offer} key={offer.key} />
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ProductGrid;
